// extracted by mini-css-extract-plugin
export default {"technologies":"Skills_technologies__xMUPx","columnHeader":"Skills_columnHeader__0nIGq"};